import React from 'react';
import ReactDOM from 'react-dom';
import GOTUtil from '../../utils/GOTUtil';
import GOT from '../../utils/GOT';
import ServiceHelper from '../../remote/ServiceHelper';
import Command from '../../remote/Command';

import CommandResolver from '../../utils/CommandResolver';

import CommandTask from '../../forms/sys/remote/CommandTask';
import Cmd from '../../forms/sys/remote/Cmd';
class PivotExportDialog extends React.Component {


  constructor(props) {
    super(props);
    this.parent = props.parent;  
  }


  export(e)
  {
    var _group = this.parent;
    var htmlarg = _group.doPivotExport();
    this.state = htmlarg;
    var label = "";
		var mainSource = _group.mainSource;	
		var tablePro = GOTUtil.getProperty(mainSource.xml,"Table");
		if(tablePro != null && tablePro.hasOwnProperty("refentityid"))
		{
			var table = GOT.getTable(tablePro.refentityid);
			if(table)
			{
				label = GOTUtil.getPropertyValue(table,"Label");
				if(!label)
				{
					label = mainSource.xml.name;
				}
			}
		}
    var array = this.getExportHeadData();
    var command = Command.createService("gongqi.erp.layers.sys.services.ExportService", "exportExcel", "String");
		command.appendArg(label);

    command.appendArg(array,"List");


		var _exportDataProvider=[];
				
		for(let i = 0;i<this.state.ac.length;i++)
		{
			var item = this.state.ac[i];
			var _exportItem = {};
			for(let j = 0;j<array.length;j++)
			{
				let field = array[j];
				_exportItem[field.dataField] = item[field.dataField]+"";
				if(_exportItem[field.dataField] =='' ||_exportItem[field.dataField] == "undefined" || _exportItem[field.dataField]  ==null ||_exportItem[field.dataField] == "null"){
					if(field.fieldType == "Decimal" || field.fieldType=="Long"){
						_exportItem[field.dataField] = 0;
					}else{
						_exportItem[field.dataField] = "";
					}
				}		
			}
			_exportDataProvider.push(_exportItem);
		}
		command.appendArg(_exportDataProvider,"List");
		//command.appendArg(this.state.ac,"List");
		
		ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.rpc_exportExcelHandler,sync:false});
		return;
  }

  getExportHeadData=()=>{
    var headerInfo = [];
    for(let i = 0;i<this.state.columns.length;i++)
    {
      let col = this.state.columns[i];
      if(col.selected)
      {
        let _headerText = this.state.showTableName?col.totalHeaderText:(col.headerText||col.normalHeaderText);
        let item = {dataField:col.dataField, headerText:_headerText, fieldType:col.fieldType};
        if(col.fieldType == "Decimal")
        {
          if(!col.numOfDecimals)
          {
            for(let key in FormItemUtil.formItemControlsForFor)
              {
                  let fe = FormItemUtil.formItemControlsForFor[key];
                  if(col.formItemId == fe.xml.id)
                  {
                    item.numOfDecimals = fe.getProperty_NumOfDecimals();
                    break;
                  }
                }	
          }
          else
          {
            item.numOfDecimals = col.numOfDecimals;
          }

          if(typeof(item.numOfDecimals) == "string")
          {
            try
            {
              item.numOfDecimals = parseInt(item.numOfDecimals);
            }
            catch(e)
            {
              item.numOfDecimals = 2;
            }
            
          }
          
        }
        headerInfo.push(item);
      }
    }
    return headerInfo;
    }

  	rpc_exportExcelHandler=(data)=>{
  		if(data)
  		{
  			var commandTask = new CommandTask();
	  		commandTask.cmd = Cmd.FileDownload;
	  		commandTask.arg = data.result;
	  		CommandResolver.downLoad(commandTask,window.formModuleInstance);
  		}
  	}
  componentDidMount () {
    $("#pivotExportModal .modal").children(':first').draggable({ cursor: "move", containment: "parent" });
  }


  render () {
    
    return (
      <div className="modal " style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <div className=" ui-draggable" style={{ alignSelf: "center", display: 'flex', flexFlow: 'column', background: "#ffffff", background: '#FFFFFF', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px', width: '400px' }}>
          <div className="modal-header" style={{ position: "relative" }}>
            <div className="modal-close" onClick={this.closeAttachmentHandler.bind(this)}></div>
            <h5 className="modal-title">提示</h5>
          </div>

          <div className="modal-content">
						<div className="" style={{borderTop: '1px solid #d2d6de',textAlign:'center'}}>
							<div className="box-body" style={{paddingTop:'0px'}}>
								<div style={{width:'100%',display:'flex',alignItems: 'center',justifyContent: 'center'}}>
								<h5>当前数据量过大,暂时无法使用该工具进行分析<br/><br/>请下载EXCEL之后利用其他工具处理</h5>
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer" >
						<button type="button" className="btn" style={{height:'28px',marginRight:'5px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',paddingTop:'3px'}} id="dataSourceDoMain_BtnCancel" data-dismiss="modal" onClick={this.closeAttachmentHandler.bind(this)}>取消</button>
						<button type="button" className="btn" style={{height:'28px',marginRight:'0px',width:'100px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',paddingTop:'3px',color:'#fff'}} onClick={this.export.bind(this)}>下载EXCEL</button>
					</div>
        </div> 
      </div>
    );
  }
  closeAttachmentHandler () {
    //关掉要卸载
    let $reactComponentContainer = $("#pivotExportModal .modal");
    ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
    $reactComponentContainer.remove();
  }
}

PivotExportDialog.defaultProps = {
  

};

export default PivotExportDialog;



// WEBPACK FOOTER //
// ./src/components/pivotExport/PivotExportDialog.js